const SCREEN_SIZE_XS_IN_PX = 576;
const IS_SMALL_SCREEN = window.innerWidth < SCREEN_SIZE_XS_IN_PX;

export default function useIsSmallScreen() {
  return {
    isSmallScreen: IS_SMALL_SCREEN,
    width: window.innerWidth,
  };
}
